import * as React from 'react';
import { map } from 'es-toolkit/compat';
import clsx from 'clsx';

import {
  AerialTableShapeOptions,
  getIconForShape,
  getNameForShape,
  getSelectedShape,
} from 'constants/AerialConstants';

interface Props {
  selectedShape: string;
  onSelect(event: React.MouseEvent<HTMLElement>): void;
}

const TablePopoverShapeSelector = (props: Props) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const options = map(AerialTableShapeOptions, (option: any) => {
    return {
      ...option,
      iconClassName: getIconForShape(option.key),
      name: getNameForShape(option.key),
    };
  });
  return (
    <div className="TablePopoverShapeSelector">
      <div className="TablePopoverShapeSelector-title">Shape</div>
      <div className="TablePopoverShapeSelector-options">
        {map(options, (option) => {
          return (
            <div
              key={option.value}
              className={'TablePopoverShapeSelector-option'}
              data-name={option.value}
              onClick={props.onSelect}
            >
              <div className="TablePopoverShapeSelector-optionShapeArea">
                <div
                  className={clsx('TablePopoverShapeSelector-optionShape', option.iconClassName)}
                />
              </div>
              <div className="TablePopoverShapeSelector-optionLabel">{option.name}</div>
              <input
                checked={getSelectedShape(option.value, props.selectedShape)}
                className="TablePopoverShapeSelector-optionRadioIndicator"
                readOnly={true}
                type="radio"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TablePopoverShapeSelector;
